export const config = {
  apiUrl: process.env.REACT_APP_BASE_URL,
  stripeQuarterlyProductPaymentUrl: process.env.REACT_APP_STRIPE_QUARTERLY_PRODUCT_PAYMENT_URL
}
